<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Experiment Logs
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" 
              @click="fetchLogs()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="logListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.fold}}</td>
                <td>{{ props.item.epoch}}</td>
                <td>{{ props.item.globalStep}}</td>
                <td>{{ props.item.trainLoss | formatPrec}}</td>
                <td>{{ props.item.evalLoss | formatPrec}}</td>
                <td>{{ props.item.evalError | formatPrec}}</td>
                <td>{{ props.item.evalAccuracy | formatPrec}}</td>
                <td>{{ props.item.microRocAuc | formatPrec}}</td>
                <td>{{ props.item.avgPrecision | formatPrec}}</td>
                <td>{{ props.item.avgRecall | formatPrec}}</td>
                <td>{{ props.item.avgFscore | formatPrec}}</td>
                <td class="text-xs-right">
                  <v-tooltip bottom color="accent">
                    <v-icon
                      color="accent"
                      slot="activator"
                      @click="labelDialog = true; fetchLabelLogs(props.item.id);"
                    >
                      list_alt
                    </v-icon>
                    <span>Show Config</span>
                  </v-tooltip>

                </td>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td></td>
                  <td>
                    <v-select v-model="level" type="select" label="Level Filter"></v-select>
                  </td>
                  <td colspan="4"></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="labelDialog"
      persistent
      scrollable
      width="800"
      >
      <v-card>
        <v-card-title primary-title class="primary white--text headline">Label Results</v-card-title>
          <v-card-text>
            <v-data-table
            hide-actions
            :headers="labelHeaders"
            :items="labelItems"
            :loading="labelLogListLoading">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.label }}</td>
                <td>{{ props.item.precision | formatPrec }}</td>
                <td>{{ props.item.recall | formatPrec }}</td>
                <td>{{ props.item.fScore | formatPrec }}</td>
                <td>{{ props.item.accuracy | formatPrec }}</td>
                <td>{{ props.item.rocAuc | formatPrec }}</td>
                <td>{{ props.item.support }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            @click="labelItems = []; labelDialog = false;"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
      default: ''
    },
    logId: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      headers: [
        {text: 'Fold', sortable: true, value: 'fold'},
        {text: 'Epoch', sortable: true, value: 'epoch'},
        {text: 'Global Step', sortable: true, value: 'globalStep'},
        {text: 'Training Loss', sortable: true, value: 'trainLoss'},
        {text: 'Eval Loss', sortable: true, value: 'evalLoss'},
        {text: 'Eval Error', sortable: true, value: 'evalError'},
        {text: 'Eval Accuracy', sortable: true, value: 'evalAccuracy'},
        {text: 'Micro Roc Auc', sortable: true, value: 'microRocAuc'},
        {text: 'Average Precision', sortable: true, value: 'avgPrecision'},
        {text: 'Average Recall', sortable: true, value: 'avgRecall'},
        {text: 'Average F1', sortable: true, value: 'avgFscore'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      labelHeaders: [
        {text: 'Label', sortable: true, value: 'label'},
        {text: 'Precision', sortable: true, value: 'precision'},
        {text: 'Recall', sortable: true, value: 'recall'},
        {text: 'F1', sortable: true, value: 'fScore'},
        {text: 'Accuracy', sortable: true, value: 'accuracy'},
        {text: 'Roc-Auc', sortable: true, value: 'rocAuc'},
        {text: 'Support', sortable: true, value: 'support'},
      ],
      items: [],
      labelItems: [],
      logListLoading: false,
      labelLogListLoading: false,
      pagination: {
        sortBy: 'global_step'
      },
      search: ''
    }
  },
  created () {
    this.fetchLogs()
  },
  methods: {
    fetchLogs () {
      this.logListLoading = true
      this.items = []
      this.axios.get(`/jobs/${this.id}/logs/${this.logId}/`)
        .then(response => {
          response.data.forEach(log => {
            this.items.push({
              id: log.id,
              fold: log.fold,
              epoch: log.epoch,
              globalStep: log.global_step,
              trainLoss: log.train_loss,
              evalLoss: log.eval_loss,
              evalError: log.eval_error,
              evalAccuracy: log.eval_accuracy,
              microRocAuc: log.micro_roc_auc,
              avgPrecision: log.avg_precision,
              avgRecall: log.avg_recall,
              avgFscore: log.avg_f_score
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.logListLoading = false
        })
    },
    fetchLabelLogs (expID) {
      this.labelLogListLoading = true
      this.labelItems = []
      this.axios.get(`/jobs/${this.id}/logs/${this.logId}/label/${expID}/`)
        .then(response => {
          response.data.forEach(log => {
            this.labelItems.push({
              label: log.label,
              precision: log.precision,
              recall: log.recall,
              fScore: log.f_score,
              accuracy: log.accuracy,
              rocAuc: log.roc_auc,
              support: log.support,
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.labelLogListLoading = false
        })
    }
  }
}
</script>

<style>

</style>
